module.exports = __webpack_public_path__ + "img/Quickspin-1024x246.d6ecf5f8.png";